import Vue from 'vue'
import App from './App.vue'
import store from './store/'

import 'current-device'

import 'reset-css'
import '@/assets/styles/abstracts/_utilities.scss'
import '@/assets/styles/base/_fonts.scss'
import '@/assets/styles/common.scss'

import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill();

import VueGtag from 'vue-gtag'
Vue.use(VueGtag, {
  config: { 
    id: 'UA-249486145-1',
    params: {
      send_page_view: true
    }
  }
});

Vue.prototype.$trackPage = function(pageName) {
  this.$gtag.pageview({
    page_path: '/' + pageName,
  })
}

Vue.prototype.$trackEvent = function(category, action, label) {
  this.$gtag.event(action, {
    'event_category': category,
    'event_label': label
  })
}

import VueYoutube from 'vue-youtube'
Vue.use(VueYoutube)

Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'));
  },
}).$mount('#app')
